import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ListaDadosAcaoLinha, ListaDadosColuna } from 'src/app/components/lista-dados/lista-dados.component';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { DialogTokenGeradoComponent } from 'src/app/components/dialog-token-gerado/dialog-token-gerado.component';
import { DialogUsuarioTokenRegrasComponent } from 'src/app/components/dialog-usuario-token-regras/dialog-usuario-token-regras.component';
import { BeUsuarioToken } from 'src/app/models/BeUsuarioToken';
import { BeUsuario } from 'src/app/models/BeUsuario';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({ selector: 'app-usuario-tokens', templateUrl: './list-usuario-tokens.component.html' })
export class ListUsuarioTokensComponent implements OnInit {
  @Input() public usuario?: BeUsuario;

  public tokens: BeUsuarioToken[] = [];
  public carregando = false;
  public colunas: ListaDadosColuna[] = [
    {
      campo: 'noDescricao',
      rotulo: 'Descrição',
      tamanho: '80%',
      editavel: true,
      edicao: {
        tipoEditor: 'texto',
        validacao: {
          obrigatorio: true,
          maxLength: 100
        }
      }
    },
    {
      campo: 'ativo',
      rotulo: 'Status',
      tamanho: '20%',
      editavel: false,
      tipoExibicao: 'status'
    },
  ];
  public acoesLinha: ListaDadosAcaoLinha[] = [
    {
      chave: 'revogar',
      texto: 'Revogar',
      icone: 'block',
      visivel: token => !!token?.ativo
    },
    {
      chave: 'desfazer-revogacao',
      texto: 'Desfazer revogação',
      icone: 'undo',
      visivel: token => !!token && !token.ativo
    }
  ];

  public constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    private snack: SnackBarService
  ) { }

  public ngOnInit(): void {
    this.carregar();
  }

  public iniciar(row: BeUsuarioToken): void {
    if (!row.idUsuarioToken)
      row.idUsuario = this.usuario?.idUsuario;
  }

  public salvar(row: BeUsuarioToken): void {
    if (!row.idUsuario || row.idUsuarioToken)
      return;
    this.carregando = true;
    this.http.post<{ idUsuarioToken: number, noDescricao: string, token: string }>('/api/UsuarioTokens', { idUsuario: row.idUsuario, noDescricao: row.noDescricao })
      .subscribe({
        next: res => {
          row.idUsuarioToken = res.idUsuarioToken;
          row.noDescricao = res.noDescricao;
          row.ativo = true;
          this.tokens = [...this.tokens];
          this.carregando = false;
          this.dialog.open(DialogTokenGeradoComponent, { width: '620px', disableClose: true, data: { token: res.token } });
        },
        error: err => { this.carregando = false; this.snack.exibirErro(`Erro! - ${err.status} - ${err.statusText}`); }
      });
  }

  public abrirPermissoes(token: BeUsuarioToken): void {
    if (!token.idUsuarioToken || !this.usuario?.listaUsuarioXRegras)
      return;
    this.carregando = true;
    this.http.get<number[]>(`/api/UsuarioTokens/${token.idUsuarioToken}/Regras`).subscribe({
      next: selecionadas => {
        this.carregando = false;
        const regras = this.usuario!.listaUsuarioXRegras!.map(item => item.regra!).filter(Boolean);
        this.dialog.open(DialogUsuarioTokenRegrasComponent, { width: '480px', data: { regras, selecionadas } })
          .afterClosed()
          .subscribe(ids => {
            if (!ids) return;
            this.carregando = true;
            this.http.put(`/api/UsuarioTokens/${token.idUsuarioToken}/Regras`, ids)
              .subscribe({
                next: () => {
                  this.carregando = false;
                  this.snack.exibirSucesso('Permissões atualizadas!');
                },
                error: err => {
                  this.carregando = false;
                  this.snack.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
                }
              });
          });
      }, error: err => {
        this.carregando = false;
        this.snack.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  public revogar(token: BeUsuarioToken): void {
    if (!token.idUsuarioToken || !token.ativo) return;
    this.dialog.open(DialogComponent, {
      data: {
        title: 'Alerta',
        message: 'Deseja revogar este token?',
        buttonText: 'Não',
        secondButtonText: 'Sim'
      }
    }).afterClosed()
      .subscribe(ok => {
        if (!ok) return;
        this.carregando = true; this.http.post(`/api/UsuarioTokens/${token.idUsuarioToken}/Revogar`, {})
          .subscribe({
            next: () => {
              token.ativo = false;
              token.dtRevogacao = new Date().toISOString();
              this.tokens = [...this.tokens];
              this.carregando = false;
              this.snack.exibirSucesso('Token revogado!');
            },
            error: err => {
              this.carregando = false;
              this.snack.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
            }
          });
      });
  }

  public desfazerRevogacao(token: BeUsuarioToken): void {
    if (!token.idUsuarioToken || token.ativo) return;
    this.dialog.open(DialogComponent, {
      data: {
        title: 'Alerta',
        message: 'Deseja desfazer a revogação deste token?',
        buttonText: 'Não',
        secondButtonText: 'Sim'
      }
    }).afterClosed()
      .subscribe(ok => {
        if (!ok) return;
        this.carregando = true; this.http.post(`/api/UsuarioTokens/${token.idUsuarioToken}/DesfazerRevogacao`, {})
          .subscribe({
            next: () => {
              token.ativo = true;
              token.dtRevogacao = null;
              this.tokens = [...this.tokens];
              this.carregando = false;
              this.snack.exibirSucesso('Revogação desfeita!');
            },
            error: err => {
              this.carregando = false;
              this.snack.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
            }
          });
      });
  }

  public excluir(token: BeUsuarioToken): void {
    if (!token.idUsuarioToken) return;
    this.dialog.open(DialogComponent, {
      data: {
        title: 'Alerta',
        message: 'Deseja excluir este token?',
        buttonText: 'Não',
        secondButtonText: 'Sim'
      }
    }).afterClosed()
      .subscribe(ok => {
        if (!ok) return;
        this.carregando = true; this.http.delete(`/api/UsuarioTokens/${token.idUsuarioToken}`)
          .subscribe({
            next: () => {
              this.tokens = this.tokens.filter(item => item.idUsuarioToken !== token.idUsuarioToken);
              this.carregando = false;
              this.snack.exibirSucesso('Token excluído!');
            },
            error: err => {
              this.carregando = false;
              this.snack.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
            }
          });
      });
  }

  public executarAcaoLinha(evento: { chave: string; linha: BeUsuarioToken }): void {
    if (evento.chave === 'revogar') {
      this.revogar(evento.linha);
      return;
    }

    if (evento.chave === 'desfazer-revogacao') {
      this.desfazerRevogacao(evento.linha);
    }
  }

  private carregar(): void {
    if (!this.usuario?.idUsuario)
      return;
    this.carregando = true;
    this.http.get<BeUsuarioToken[]>(`/api/UsuarioTokens/Usuario/${this.usuario.idUsuario}`)
      .subscribe({
        next: tokens => {
          this.tokens = tokens.map(t => ({ ...t, ativo: !t.dtRevogacao }));
          this.carregando = false;
        },
        error: err => {
          this.carregando = false;
          this.snack.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
        }
      });
  }
}
